import { create } from 'zustand';
import { conditionalDevtools } from '@/lib/storeMiddleware';
import type { SenderGroupInfo } from '@/features/email-list/types';

const EMPTY_EMAIL_IDS: string[] = [];

interface HoverState {
  // Currently hovered email ID
  hoveredEmailId: string | null;

  // Currently hovered sender group
  hoveredSenderGroupKey: string | null;
  hoveredSenderGroupEmailIds: string[];
  hoveredSenderGroupInfo: SenderGroupInfo | null;

  // Actions
  setHoveredEmail: (emailId: string | null) => void;
  setHoveredSenderGroup: (groupKey: string | null, emailIds?: string[], groupInfo?: SenderGroupInfo | null) => void;
  clearHover: () => void;
}

export const useHoverStore = create<HoverState>()(
  conditionalDevtools(
    (set, get) => ({
      hoveredEmailId: null,
      hoveredSenderGroupKey: null,
      hoveredSenderGroupEmailIds: EMPTY_EMAIL_IDS,
      hoveredSenderGroupInfo: null,

      setHoveredEmail: (emailId) => {
        const state = get();
        if (state.hoveredEmailId === emailId && state.hoveredSenderGroupKey === null) {
          return;
        }
        set({
          hoveredEmailId: emailId,
          hoveredSenderGroupKey: null,
          hoveredSenderGroupEmailIds: EMPTY_EMAIL_IDS,
          hoveredSenderGroupInfo: null,
        });
      },

      setHoveredSenderGroup: (groupKey, emailIds = EMPTY_EMAIL_IDS, groupInfo = null) => {
        const state = get();
        if (state.hoveredSenderGroupKey === groupKey && state.hoveredEmailId === null) {
          return;
        }
        set({
          hoveredEmailId: null,
          hoveredSenderGroupKey: groupKey,
          hoveredSenderGroupEmailIds: emailIds,
          hoveredSenderGroupInfo: groupInfo,
        });
      },

      clearHover: () => {
        const state = get();
        if (state.hoveredEmailId === null && state.hoveredSenderGroupKey === null) {
          return;
        }
        set({
          hoveredEmailId: null,
          hoveredSenderGroupKey: null,
          hoveredSenderGroupEmailIds: EMPTY_EMAIL_IDS,
          hoveredSenderGroupInfo: null,
        });
      },
    }),
    { name: 'HoverStore' }
  )
);
